module.exports = __webpack_public_path__ + "img/austshirtday-2024.04ad1c91.gif";